import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'small-button',
    template: `
<button matButton class="small" [disabled]="disabled"><ng-content></ng-content></button>
`,
    styles: [`
  :host .mat-button.small:hover { background: var(--primaryhover); color: var(--pagebackground); }
  `],
    standalone: true,
    imports: [CommonModule, MatButtonModule]
})
export class SmallButtonComponent {
  @Input() disabled = false
}
